import CustomTitleBar from 'src/components/GuideMeTitleBar';
import Button from 'src/components/design-system/Button';
import useViewDepartments from 'src/hooks/useViewDepartments';
import { informationIcon } from 'src/utils/icons';
const ViewDepartmentContent = () => (
  <ul className="px-4 font-bold text-[13px]">
    <li className="list-disc font-semibold">
      <span className="inline-flex items-center">
        Click
        <span className="mx-1">{informationIcon}</span>
      </span>
      in the Department GL Codes column to view and/or export GL Codes assigned
    </li>
    <li className="list-disc font-semibold">
      <span className="inline-flex items-center">
        Click
        <span className="mx-1">{informationIcon}</span>
      </span>
      in the Department Members column to view and/or export Members assigned to the department
      present in that row.
    </li>
  </ul>
);

const EditDepartmentContent = () => (
  <ul className="px-4 font-bold text-[13px]">
    <li className="list-disc font-semibold">
      Click
      <Button color="success" className="inline-block" size="lg" readonly={true}>
        Add New Department
      </Button>
      to add a new department.
    </li>
    <li className="list-disc font-semibold">
      Click on a value in the department name column to rename the department.
    </li>
    <li className="list-disc font-semibold">
      <span className="inline-flex items-center">
        Click
        <span className="mx-1">{informationIcon}</span>
      </span>
      in the Department GL Codes column to view or export GL Codes assigned to department present in
      that row.
    </li>
    <li className="list-disc font-semibold">
      <span className="inline-flex items-center">
        Click
        <span className="mx-1">{informationIcon}</span>
      </span>
      in the Department Members column to view or export Members assigned to department present in
      that row.
    </li>
    <li className="list-disc font-semibold">
      Click
      <Button color="success" className="inline-block" size="lg" readonly={true}>
        Edit
      </Button>
      present in Department GL Codes/Members column to assign and unassign GL Codes and Members for
      the department present in that row.
    </li>
    <li className="list-disc font-semibold">
      Use the Checkbox column to select eligible Departments for Deletion, and click{' '}
      <Button color="error" className="inline-block" size="lg" readonly={true}>
        Delete
      </Button>{' '}
      to delete in bulk.
    </li>
    <li className="list-disc font-semibold">
      Use the Checkbox column to select eligible Department and click{' '}
      <Button color="submit" className="inline-block" size="lg" readonly={true}>
        Copy
      </Button>{' '}
      to copy GL Codes, Members or both to a new department.
    </li>
    <li className="list-disc font-semibold">
      Use the Checkbox column to select eligible Departments and click{' '}
      <Button color="success" className="inline-block" size="lg" readonly={true}>
        Bulk Member Update
      </Button>{' '}
      to assign or unassign Members in bulk
    </li>
    <li className="list-disc font-semibold">
      Use the Checkbox column to select eligible Departments and click{' '}
      <Button color="success" className="inline-block" size="lg" readonly={true}>
        Bulk GL Code Update
      </Button>{' '}
      to assign or unassign GL Codes in bulk
    </li>
  </ul>
);
export const useGuideMeSteps = () => {
  const { hasEditDepartmentPermission } = useViewDepartments();

  return [
    ...(hasEditDepartmentPermission
      ? [
          {
            title: (
              <CustomTitleBar
                title={'View/Edit Department'}
                className="font-bold text-xl text-red-600"
              />
            ),
            content: <EditDepartmentContent />,
          },
        ]
      : [
          {
            title: (
              <CustomTitleBar
                title={'View Department'}
                className="font-bold text-xl text-red-600"
              />
            ),
            content: <ViewDepartmentContent />,
          },
        ]),
  ];
};
